import React from 'react'
import ReactDOM from 'react-dom'
import axios from 'axios'
import { createBrowserHistory } from 'history'
import { Router } from 'react-router-dom'
import { Provider } from 'react-redux'
import * as Sentry from '@sentry/react'
// import ReactGA from 'react-ga'
import store from './store'
import App from 'components/App'
import ErrorBoundary from 'components/utils/ErrorBoundary'
// import { logout } from 'actions/CurrentUser'
// import { displayToast } from 'actions/Dashboard'
// import reportWebVitals from './reportWebVitals'
import './index.scss'
import { init as initFullStory } from '@fullstory/browser'

// if (process.env.REACT_APP_GA_TRACKING_ID) {
//   ReactGA.initialize(process.env.REACT_APP_GA_TRACKING_ID)
// }

const history = createBrowserHistory()

axios.defaults.baseURL = process.env.REACT_APP_AUTH_URL
axios.defaults.withCredentials = true
axios.interceptors.response.use(
  (resp) => resp,
  (error) => {
    const requestUrl = error?.config?.url || ''
    const isLoginAttempt = requestUrl.includes('/oauth/login-cookie')

    if (error?.response?.status === 401 && !isLoginAttempt) {
      // store.dispatch(
      //   displayToast({
      //     message:
      //       'There was a problem accessing your data. You must be signed in to access this part of the application. Your session may have expired.',
      //     title: 'Error: Unauthorized',
      //     infoType: 'danger',
      //   }),
      // )
      history.push('/welcome')
    }
    return Promise.reject(error)
  },
)

if (process.env.NODE_ENV !== 'development') {
  if (typeof process.env.REACT_APP_SENTRY_DSN !== 'string')
    throw new Error('Sentry DSN not set.')

  const buildMetaEl = document.querySelector("meta[name='build-version']")
  const buildVersion = buildMetaEl?.getAttribute('content') || 'unknown'
  const sentryOptions: Sentry.BrowserOptions = {
    dsn: process.env.REACT_APP_SENTRY_DSN,
    release: buildVersion,
    environment: process.env.REACT_APP_ENVIRONMENT,
    tunnel: `${process.env.REACT_APP_AUTH_URL}/sentry_tunnel`,
    transportOptions: {
      dsn: process.env.REACT_APP_SENTRY_DSN,
      fetchParameters: {
        credentials: 'include',
      },
    },
  }
  Sentry.init(sentryOptions)
}

if (process.env.NODE_ENV === 'production') {
  initFullStory({ orgId: 'o-1ZQKTS-na1' })
}

ReactDOM.render(
  <Provider store={store}>
    <Router history={history}>
      <React.StrictMode>
        <Sentry.ErrorBoundary fallback={ErrorBoundary}>
          <App />
        </Sentry.ErrorBoundary>
      </React.StrictMode>
    </Router>
  </Provider>,
  document.getElementById('root'),
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals()
